<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="accordion-item">
    <h2 class="accordion-header" id="panelsStayOpen-headingTwoMore">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#panelsStayOpen-collapseTwoMore"
        aria-expanded="false"
        aria-controls="panelsStayOpen-collapseTwoMore"
      >
        <div class="col-6">Condiciones del Cr&eacute;dito</div>
        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%">
          {{ solicitud.producto }}
        </div>
      </button>
    </h2>

    <div
      id="panelsStayOpen-collapseTwoMore"
      class="accordion-collapse collapse"
      aria-labelledby="panelsStayOpen-headingTwoMore"
    >
      <div class="accordion-body">
        <div class="condiciones-fieldset">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <label class="col-sm-9 col-form-label">Selecciona el Producto</label>
            <div class="col-sm-9 d-flex align-items-center">


              <select
                v-model="productoSeleccionadoIdModel"
                @change="seleccionarProductoPorId"
                class="form-select"
                aria-label="Default select example"
                :disabled="soloLectura"
                required
              >
                <option disabled value="">
                  {{ productosReady ? 'Selecciona una opcion' : 'Cargando productos...' }}
                </option>
                <option
                  v-for="producto in productosSeleccionables"
                  :key="producto.id || producto.nombre"
                  :value="String(producto.id)"
                >
                  {{ producto.nombre }}
                </option>
              </select>

              <small v-if="productosError" class="text-danger ms-2">
                No se pudieron cargar los productos.
              </small>
              <small v-else-if="productoConfigLoading" class="text-muted ms-2">
                Cargando configuracion...
              </small>
              <small v-else-if="productoConfigError" class="text-danger ms-2">
                No se pudo cargar la configuracion del producto.
              </small>
            </div>
          </div>

          <div class="col-12 col-lg-6 mb-3">
            <label class="col-sm-9 col-form-label">Sucursal</label>
            <div class="col-sm-9 d-flex align-items-center">
              <select
                v-model="solicitud.sucursalId"
                id="sucursal"
                name="sucursal"
                class="form-select"
                :disabled="soloLectura"
                required
              >
                <option :value="0">Sin Sucursal</option>
                <option
                  v-for="(departamento, index) in departamentos"
                  :key="departamento.id || index"
                  :value="departamento.id || departamento"
                >
                  {{ departamento.nombre || departamento }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div id="contenedor-plan">
          <div name="frmPrestamo" id="frmPrestamo">
            <div v-if="esCrediTrabajo2" class="control d-flex flex-column">
              <h4>Producto: {{ productoSeleccionadoNombre }}</h4>
              <label class="mb-2">
                <strong>Monto Credito:</strong>
                {{ formatoNumero(solicitud.monto) }} {{ moneda }}
              </label>
              <label for="interes">
                <strong>Inter&eacute;s (anual):</strong>
                {{ solicitud.interes }} % ({{ formatoNumero(montoInteres) }} {{ moneda }})
              </label>
              <label for="interes">
                <strong>Inter&eacute;s (mensual):</strong>
                {{ solicitud.interes / 12 }} %
              </label>
              <label for="interes">
                <strong>Comisi&oacute;n por otorgamiento:</strong>
                {{ comisionOtorgamiento }} % ({{ formatoNumero(totalComisionOtorgamiento) }} {{ moneda }})
              </label>
              <label for="interes">
                <strong>Comisi&oacute;n por asistencia t&eacute;cnica:</strong>
                {{ comisionAsistenciaTecnica }} %
                ({{ formatoNumero(totalComisionAsistenciaTecnica) }} {{ moneda }})
              </label>
              <label for="interes">
                <strong>Tasa de seguridad:</strong>
                {{ tasaSeguridad }} % ({{ formatoNumero(totalTasaSeguridad) }} {{ moneda }})
              </label>
            </div>

            <div
              v-if="esCreaFuturo || esMicroCredito"
              class="control d-flex flex-column mt-2 mb-3"
            >
              <div class="row">
                <div class="col-12 col-lg-6 d-flex flex-column">
                  <label>
                    <strong>{{ etiquetaMontoOtorgamiento }}:</strong>
                    {{ formatoNumero(solicitud.montoOtorgar) }} {{ moneda }}
                  </label>
                  <label for="interes">
                    <strong>Comisi&oacute;n por otorgamiento:</strong>
                    {{ comisionOtorgamiento }} %
                    ({{ formatoNumero(totalComisionOtorgamiento) }} {{ moneda }})
                  </label>
                  <label for="interes">
                    <strong>Comisi&oacute;n por asistencia t&eacute;cnica:</strong>
                    {{ comisionAsistenciaTecnica }} %
                    ({{ formatoNumero(totalComisionAsistenciaTecnica) }} {{ moneda }})
                  </label>
                  <label for="interes">
                    <strong>Tasa de seguridad:</strong>
                    {{ tasaSeguridad }} % ({{ formatoNumero(totalTasaSeguridad) }} {{ moneda }})
                  </label>
                </div>

                <div class="col-12 col-lg-6 d-flex flex-column">
                  <label for="interes">
                    <strong>Reservas y seguros:</strong>
                    {{ reservasSeguros }} % ({{ formatoNumero(totalReservasSeguros) }} {{ moneda }})
                  </label>
                  <label for="interes">
                    <strong>Consultas y bur&oacute; de cr&eacute;dito:</strong>
                    {{ consultasBuro }} % ({{ formatoNumero(totalConsultasBuro) }} {{ moneda }})
                  </label>
                  <label for="interes">
                    <strong>Cobro de ACH:</strong>
                    {{ formatoNumero(cobroPorACH) }} {{ moneda }}
                  </label>
                  <label v-if="cliente" for="interes">
                    <strong>Banco:</strong>
                    {{ cliente?.nombreBanco }}
                  </label>
                </div>
              </div>
            </div>

            <div class="row condiciones-grid">
              <div class="col-12 col-lg-6 condiciones-column condiciones-column--left">
              <div class="control">
                <label for="fecha">Fecha:</label>
                <input
                  type="date"
                  :required="!modoThanos"
                  class="form-control mb-2"
                  v-model="solicitud.fechaPago"
                  name="fecha"
                  id="fecha"
                  placeholder="fecha"
                  :readonly="soloLectura"
                />
              </div>

              <div v-if="esCrediTrabajo2" class="control">
                <label for="montoOtorgar">{{ etiquetaMontoOtorgamiento }}:</label>
                {{ solicitud.montoOtorgar }}
                <input
                  type="text"
                  :required="!modoThanos"
                  class="form-control"
                  v-model="montoOtorgarModel"
                  name="montoOtorgar"
                  id="montoOtorgar"
                  placeholder="monto"
                  pattern="\d+(\.\d{1,2})?"
                  min="500"
                  max="300000"
                  :readonly="soloLectura"
                  @blur="onBlur"
                />
              </div>

              <div v-if="esCreaFuturo" class="control monto-aprobado-control">
                <label for="montoOtorgar">Monto Credito:</label>
                <input
                  type="number"
                  :required="!modoThanos"
                  class="form-control"
                  v-model="solicitud.monto"
                  name="montoOtorgar"
                  id="montoOtorgar"
                  placeholder="monto"
                  step="any"
                  :readonly="soloLectura || montoAprobadoSoloLectura"
                  :min="montoAprobadoMin"
                  :max="montoAprobadoMax"
                  :class="{ 'is-invalid': montoAprobadoFueraRango }"
                  @input="validarMontoAprobado"
                  @blur="handleMontoAprobadoBlur(true)"
                />
                <small
                  v-if="montoAprobadoMensaje"
                  class="monto-ayuda"
                  :class="montoAprobadoFueraRango ? 'text-danger' : 'text-muted'"
                >
                  {{ montoAprobadoMensaje }}
                </small>
              </div>

              <div v-else class="control monto-aprobado-control">
                <label for="monto">{{ etiquetaMontoProductoDinamico }}:</label>
                <input
                  type="number"
                  :required="!modoThanos"
                  class="form-control"
                  v-model="montoProductoDinamicoModel"
                  name="monto"
                  id="monto"
                  placeholder="monto"
                  step="any"
                  :readonly="soloLectura || montoProductoDinamicoSoloLectura"
                  :min="montoProductoDinamicoMin"
                  :max="montoProductoDinamicoMax"
                  :class="{ 'is-invalid': montoAprobadoFueraRango }"
                  @input="validarMontoAprobado"
                  @blur="handleMontoAprobadoBlur(false)"
                />
                <small
                  v-if="montoProductoDinamicoMensaje"
                  class="monto-ayuda"
                  :class="montoAprobadoFueraRango ? 'text-danger' : 'text-muted'"
                >
                  {{ montoProductoDinamicoMensaje }}
                </small>
              </div>

                <div v-if="esCrediTrabajo2" class="control">
                  <label for="plazo">Plazo: (Mensual)</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Plazo Pago"
                    :required="!modoThanos"
                    name="plazo"
                    v-model="solicitud.plazoPago"
                    id="plazo"
                    :readonly="soloLectura || plazoPagoSoloLectura"
                    :min="plazoPagoMin"
                    :max="plazoPagoMax"
                    step="1"
                    :class="{ 'is-invalid': plazoPagoFueraRango }"
                    @input="validarPlazoPago"
                    @blur="handlePlazoPagoBlur"
                  />
                  <small
                    v-if="plazoPagoMensaje"
                    class="monto-ayuda"
                    :class="plazoPagoFueraRango ? 'text-danger' : 'text-muted'"
                  >
                    {{ plazoPagoMensaje }}
                  </small>
                </div>

                <div
                  v-else-if="solicitud.frecuenciaPago == 'semestral' || solicitud.frecuenciaPago == 'anual'"
                  class="control"
                >
                  <label for="plzao">Periodo de pago:</label>
                  <select
                    v-model="solicitud.plazoPago"
                    :required="!modoThanos"
                    class="form-control"
                    name="plazo"
                    id="plzao"
                    :disabled="soloLectura || plazoPagoSoloLectura"
                    :class="{ 'is-invalid': plazoPagoFueraRango }"
                    @change="validarPlazoPago"
                    @blur="handlePlazoPagoBlur"
                  >
                    <option
                      v-if="mostrarPlazoFijoSemestralAnual"
                      :value="String(plazoFijoValor)"
                    >
                      {{ plazoFijoValor }} Meses
                    </option>
                    <option value="6">6 Meses</option>
                    <option value="12">12 Meses</option>
                    <option value="18">18 Meses</option>
                    <option value="24">24 Meses</option>
                    <option value="36">36 Meses</option>
                    <option value="48">48 Meses</option>
                    <option value="60">60 Meses</option>
                    <option value="72">72 Meses</option>
                  </select>
                  <small
                    v-if="plazoPagoMensaje"
                    class="monto-ayuda"
                    :class="plazoPagoFueraRango ? 'text-danger' : 'text-muted'"
                  >
                    {{ plazoPagoMensaje }}
                  </small>
                </div>

                <div
                  v-else-if="solicitud.frecuenciaPago == 'trimestral'"
                  class="control"
                >
                  <label for="plzao">Periodo de pago:</label>
                  <select
                    v-model="solicitud.plazoPago"
                    :required="!modoThanos"
                    class="form-control"
                    name="plazo"
                    id="plzao"
                    :disabled="soloLectura || plazoPagoSoloLectura"
                    :class="{ 'is-invalid': plazoPagoFueraRango }"
                    @change="validarPlazoPago"
                    @blur="handlePlazoPagoBlur"
                  >
                    <option
                      v-if="mostrarPlazoFijoTrimestral"
                      :value="String(plazoFijoValor)"
                    >
                      {{ plazoFijoValor }} Meses
                    </option>
                    <option value="3">3 Meses</option>
                    <option value="6">6 Meses</option>
                    <option value="9">9 Meses</option>
                    <option value="12">12 Meses</option>
                    <option value="15">15 Meses</option>
                    <option value="18">18 Meses</option>
                    <option value="21">21 Meses</option>
                    <option value="24">24 Meses</option>
                    <option value="27">27 Meses</option>
                    <option value="30">30 Meses</option>
                    <option value="36">36 Meses</option>
                    <option value="48">48 Meses</option>
                    <option value="60">60 Meses</option>
                    <option value="72">72 Meses</option>
                  </select>
                  <small
                    v-if="plazoPagoMensaje"
                    class="monto-ayuda"
                    :class="plazoPagoFueraRango ? 'text-danger' : 'text-muted'"
                  >
                    {{ plazoPagoMensaje }}
                  </small>
                </div>

                <div v-else class="control">
                  <label for="plazo">Plazo: (Mensual)</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Plazo Pago"
                    :required="!modoThanos"
                    name="plazo"
                    v-model="solicitud.plazoPago"
                    id="plazo"
                    :readonly="soloLectura || plazoPagoSoloLectura"
                    :min="plazoPagoMin"
                    :max="plazoPagoMax"
                    step="1"
                    :class="{ 'is-invalid': plazoPagoFueraRango }"
                    @input="validarPlazoPago"
                    @blur="handlePlazoPagoBlur"
                  />
                  <small
                    v-if="plazoPagoMensaje"
                    class="monto-ayuda"
                    :class="plazoPagoFueraRango ? 'text-danger' : 'text-muted'"
                  >
                    {{ plazoPagoMensaje }}
                  </small>
                </div>

              <div v-if="!esCrediTrabajo2" class="control">
                <label for="interes">Inter&eacute;s (anual):</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="solicitud.interes"
                  :required="!modoThanos"
                  name="interes"
                  id="interes"
                  placeholder="inter&eacute;s"
                  :readonly="soloLectura || interesAnualSoloLectura || esMicroCredito"
                  :min="interesAnualMin"
                  :max="interesAnualMax"
                  step=".01"
                  :class="{ 'is-invalid': interesAnualFueraRango }"
                  @input="validarInteresAnual"
                  @blur="handleInteresAnualBlur"
                />
                <small
                  v-if="interesAnualMensaje"
                  class="monto-ayuda interes-ayuda"
                  :class="interesAnualFueraRango ? 'text-danger' : 'text-muted'"
                >
                  {{ interesAnualMensaje }}
                </small>
              </div>

              <div v-if="!esCrediTrabajo2" class="control">
                <label for="tasaMora">Tasa de inter&eacute;s moratorio:</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="solicitud.tasaMora"
                  :required="!modoThanos"
                  name="tasaMora"
                  id="tasaMora"
                  placeholder="inter&eacute;s moratorio"
                  :readonly="soloLectura || tasaMoraSoloLectura"
                  :min="tasaMoraMin"
                  :max="tasaMoraMax"
                  step=".01"
                  :class="{ 'is-invalid': tasaMoraFueraRango }"
                  @input="validarTasaMora"
                  @blur="handleTasaMoraBlur"
                />
                <small
                  v-if="tasaMoraMensaje"
                  class="monto-ayuda interes-ayuda"
                  :class="tasaMoraFueraRango ? 'text-danger' : 'text-muted'"
                >
                  {{ tasaMoraMensaje }}
                </small>
              </div>

              </div>

              <div class="col-12 col-lg-6 condiciones-column condiciones-column--right">
                <PlanPago
                  :fechaPago="fechaPagoPlan"
                  :monto="Number(solicitud.monto)"
                  :frecuenciaPago="solicitud.frecuenciaPago"
                  :interes="solicitud.interes"
                  :plazoPago="Number(solicitud.plazoPago || 0)"
                  :producto="productoSeleccionadoNombre"
                  :periodoGracia="solicitud.periodoGracia"
                  :fechaFija="solicitud.fechaFija"
                  :frecuenciaPagoGracia="solicitud.frecuenciaPagoGracia"
                  :pagosInteres="pagosInteres"
                />

                <div
                  v-if="mostrarComisionesProductoDinamico"
                  class="comisiones-producto"
                >
                  <div class="comisiones-producto__header">
                    <div>
                      <p class="comisiones-producto__eyebrow">Comisiones</p>
                      <h5>Detalle del producto</h5>
                    </div>
                    <div v-if="tipoComisionProductoDinamico" class="comisiones-producto__badge">
                      {{ tipoComisionProductoDinamico }}
                    </div>
                  </div>

                  <div class="comisiones-producto__summary">
                    <span>{{ etiquetaResumenMontoProductoDinamico }}</span>
                    <strong>{{ formatoNumero(montoResumenProductoDinamico) }} {{ moneda }}</strong>
                  </div>

                  <div class="comisiones-producto__list">
                    <div
                      v-for="comision in comisionesProductoDinamico"
                      :key="comision.key"
                      class="comisiones-producto__row"
                    >
                      <div>
                        <span>Comisi&oacute;n</span>
                        <strong>{{ comision.nombre }}</strong>
                      </div>
                      <div>
                        <span>Porcentaje</span>
                        <strong>{{ formatoNumero(comision.porcentaje) }} %</strong>
                      </div>
                      <div>
                        <span>Monto</span>
                        <strong>{{ formatoNumero(comision.total) }} {{ moneda }}</strong>
                      </div>
                    </div>
                  </div>

                  <div class="comisiones-producto__total">
                    <span>Total comisiones</span>
                    <strong>{{ formatoNumero(totalComisionesProductoDinamico) }} {{ moneda }}</strong>
                  </div>
                </div>

                <div class="control">
                  <label for="periodo">Periodo de pago:</label>
                  <select
                    v-model="solicitud.frecuenciaPago"
                    :required="!modoThanos"
                    class="form-control"
                    name="periodo"
                    id="periodo"
                    :disabled="soloLectura || esCrediTrabajo2"
                  >
                    <option
                      v-for="periodo in periodosPagoDisponibles"
                      :key="periodo"
                      :value="periodo"
                    >
                      {{ periodo }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div
              class="row d-flex justify-content-center align-item-center p-5"
              style="background: #f8f9fa; border-radius: 5px"
            >
              <div class="ps-5 col-12 col-lg-6 d-flex justify-content-center flex-column align-item-center">
                <div v-if="fechaFijaProductoActiva" class="form-check">
                  <input
                    v-model="solicitud.fechaFija"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="fechaFijaProducto"
                    :disabled="soloLectura || fechaFijaProductoFija"
                  />
                  <label class="form-check-label" for="fechaFijaProducto">Fecha Fija</label>
                </div>

                <div v-if="sinMoraProductoActiva" class="form-check mt-4">
                  <input
                    v-model="solicitud.sinMora"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="sinMoraProducto"
                    :disabled="soloLectura || sinMoraProductoFija"
                  />
                  <label class="form-check-label" for="sinMoraProducto">Sin Mora</label>
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div v-if="periodoGraciaProductoActivo">
                  <label for="gracia">Periodo Gracia: (Cuotas)</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Periodo Gracia"
                    name="gracia"
                    v-model="solicitud.periodoGracia"
                    id="gracia"
                    min="0"
                    :max="solicitud.plazoPago - 1"
                    step="1"
                    :readonly="soloLectura || periodoGraciaProductoFijo"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import PlanPago from "../PlanPago.vue";

export default {
  name: "CondicionesCredito",
  components: {
    PlanPago,
  },
  props: {
    solicitud: {
      type: Object,
      required: true,
    },
    solicitudCompleta: {
      type: Object,
      required: true,
    },
    productosSeleccionables: {
      type: Array,
      default: () => [],
    },
    departamentos: {
      type: Array,
      default: () => [],
    },
    pagosInteres: {
      type: Array,
      default: () => [],
    },
    cliente: {
      type: Object,
      default: () => ({}),
    },
    productoSeleccionadoId: {
      type: [String, Number],
      default: "",
    },
    productoSeleccionadoNombre: {
      type: String,
      default: "",
    },
    montoOtorgar: {
      type: [String, Number],
      default: "",
    },
    arregloPagoIntereses: {
      type: Boolean,
      default: false,
    },
    montoAPInteres: {
      type: [String, Number],
      default: 0,
    },
    noPagosAPInteres: {
      type: [String, Number],
      default: 0,
    },
    validarPagosInteres: {
      type: Boolean,
      default: false,
    },
    productosReady: {
      type: Boolean,
      default: false,
    },
    productosError: {
      type: Boolean,
      default: false,
    },
    productoConfigLoading: {
      type: Boolean,
      default: false,
    },
    productoConfigError: {
      type: Boolean,
      default: false,
    },
    modoThanos: {
      type: Boolean,
      default: false,
    },
    esCrediTrabajo2: {
      type: Boolean,
      default: false,
    },
    esCreaFuturo: {
      type: Boolean,
      default: false,
    },
    esMicroCredito: {
      type: Boolean,
      default: false,
    },
    moneda: {
      type: String,
      default: "lps",
    },
    montoInteres: {
      type: [String, Number],
      default: 0,
    },
    comisionOtorgamiento: {
      type: [String, Number],
      default: 0,
    },
    totalComisionOtorgamiento: {
      type: [String, Number],
      default: 0,
    },
    comisionAsistenciaTecnica: {
      type: [String, Number],
      default: 0,
    },
    totalComisionAsistenciaTecnica: {
      type: [String, Number],
      default: 0,
    },
    tasaSeguridad: {
      type: [String, Number],
      default: 0,
    },
    totalTasaSeguridad: {
      type: [String, Number],
      default: 0,
    },
    reservasSeguros: {
      type: [String, Number],
      default: 0,
    },
    totalReservasSeguros: {
      type: [String, Number],
      default: 0,
    },
    consultasBuro: {
      type: [String, Number],
      default: 0,
    },
    totalConsultasBuro: {
      type: [String, Number],
      default: 0,
    },
    cobroPorACH: {
      type: [String, Number],
      default: 0,
    },
    soloLectura: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "update:producto-seleccionado-id",
    "update:monto-otorgar",
    "update:arreglo-pago-intereses",
    "update:monto-a-p-interes",
    "update:no-pagos-a-p-interes",
    "seleccionar-producto",
    "blur-monto",
    "generar-pagos-interes",
    "validacion-monto",
    "validacion-interes",
    "validacion-mora",
    "validacion-plazo",
  ],
  computed: {
    fechaPagoPlan() {
      return this.solicitud.fechaPago || new Date().toISOString().slice(0, 10);
    },
    solicitudOtorgada() {
      return this.normalizarTexto(this.solicitud?.estado) === "otorgado";
    },
    etiquetaMontoOtorgamiento() {
      return this.solicitudOtorgada ? "Monto Otorgado" : "Monto por Otorgar";
    },
    productoConfiguracion() {
      const producto = this.solicitudCompleta.producto;
      return producto && typeof producto === "object" ? producto : {};
    },
    periodosPagoBase() {
      return [
        "semanal",
        "quincenal",
        "mensual",
        "al vencimiento",
        "bimensual",
        "trimestral",
        "semestral",
        "anual",
      ];
    },
    periodosPagoProducto() {
      return this.normalizarPeriodosPago(this.productoConfiguracion.periodoPago);
    },
    periodosPagoDisponibles() {
      if (this.periodosPagoProducto.length > 0) {
        return this.periodosPagoProducto;
      }

      if (this.esCrediTrabajo2) {
        return ["semanal"];
      }

      return this.periodosPagoBase;
    },
    fechaFijaProductoActiva() {
      return this.productoTieneCampo("fechaFijaActiva")
        && this.toBoolean(this.productoConfiguracion.fechaFijaActiva);
    },
    fechaFijaProductoFija() {
      return this.fechaFijaProductoActiva
        && this.toBoolean(this.productoConfiguracion.fechaFijaValue);
    },
    sinMoraProductoActiva() {
      return this.productoTieneCampo("sinMoraActiva")
        && this.toBoolean(this.productoConfiguracion.sinMoraActiva);
    },
    sinMoraProductoFija() {
      return this.sinMoraProductoActiva
        && this.toBoolean(this.productoConfiguracion.sinMoraValue);
    },
    periodoGraciaProductoActivo() {
      return this.productoTieneCampo("periodoGraciaActivo")
        && this.toBoolean(this.productoConfiguracion.periodoGraciaActivo);
    },
    periodoGraciaProductoValor() {
      return this.toNumber(this.productoConfiguracion.periodoGraciaValue);
    },
    periodoGraciaProductoFijo() {
      return this.periodoGraciaProductoActivo
        && this.productoTieneCampo("periodoGraciaValue")
        && this.hasNumber(this.productoConfiguracion.periodoGraciaValue);
    },
    comisionProductoActiva() {
      return this.toBoolean(this.productoConfiguracion.comisionActiva);
    },
    tipoComisionProductoDinamico() {
      return String(this.productoConfiguracion.tipoComision || "").trim();
    },
    tipoComisionProductoDinamicoNormalizado() {
      return this.normalizarTexto(this.tipoComisionProductoDinamico);
    },
    esComisionProductoDescontada() {
      return this.tipoComisionProductoDinamicoNormalizado === "descontada";
    },
    esComisionProductoFinanciada() {
      return this.tipoComisionProductoDinamicoNormalizado === "financiada";
    },
    esComisionProductoSeparada() {
      return this.tipoComisionProductoDinamicoNormalizado === "separada";
    },
    comisionesConfiguradasProductoDinamico() {
      let comisiones = [];

      if (Array.isArray(this.productoConfiguracion.comisiones)) {
        comisiones = this.productoConfiguracion.comisiones;
      } else if (typeof this.productoConfiguracion.comisiones === "string") {
        try {
          const comisionesParseadas = JSON.parse(this.productoConfiguracion.comisiones);
          comisiones = Array.isArray(comisionesParseadas) ? comisionesParseadas : [];
        } catch (error) {
          comisiones = [];
        }
      }

      return comisiones
        .map((comision, index) => {
          const porcentaje = this.toNumber(comision?.porcentaje);
          const nombre = String(comision?.nombre || "").trim();

          return {
            key: comision?.id || `${nombre}-${index}`,
            nombre,
            porcentaje,
          };
        })
        .filter((comision) => comision.nombre && this.hasNumber(comision.porcentaje));
    },
    porcentajeTotalComisionesProductoDinamico() {
      return this.comisionesConfiguradasProductoDinamico.reduce(
        (total, comision) => total + Number(comision.porcentaje || 0),
        0
      );
    },
    factorComisionFinanciadaProductoDinamico() {
      return 1 + (this.porcentajeTotalComisionesProductoDinamico / 100);
    },
    montoOtorgadoReferenciaProductoDinamico() {
      const montoSolicitud = this.toNumber(this.solicitud.montoOtorgar);
      if (montoSolicitud !== null && montoSolicitud > 0) {
        return montoSolicitud;
      }

      const montoProp = this.toNumber(this.montoOtorgar);
      if (montoProp !== null && montoProp > 0) {
        return montoProp;
      }

      return this.hasNumber(this.solicitud.monto) ? Number(this.solicitud.monto) : 0;
    },
    montoBaseComisionesProductoDinamico() {
      if (this.esComisionProductoFinanciada) {
        if (this.montoFijoEsOtorgadoProductoDinamico) {
          return this.montoFijoValor;
        }

        return this.montoOtorgadoReferenciaProductoDinamico;
      }

      return this.hasNumber(this.solicitud.monto) ? Number(this.solicitud.monto) : 0;
    },
    comisionesProductoDinamico() {
      return this.comisionesConfiguradasProductoDinamico.map((comision) => ({
        ...comision,
        total: this.redondearMonto((Number(comision.porcentaje) / 100) * this.montoBaseComisionesProductoDinamico),
      }));
    },
    productoDinamicoTieneComisiones() {
      return this.comisionProductoActiva && this.comisionesProductoDinamico.length > 0;
    },
    mostrarComisionesProductoDinamico() {
      return this.productoDinamicoTieneComisiones
        && !this.esCrediTrabajo2
        && !this.esCreaFuturo
        && !this.esMicroCredito;
    },
    totalComisionesProductoDinamico() {
      return this.redondearMonto(
        this.comisionesProductoDinamico.reduce(
          (total, comision) => total + Number(comision.total || 0),
          0
        )
      );
    },
    montoEntradaEsOtorgado() {
      return this.mostrarComisionesProductoDinamico && this.esComisionProductoFinanciada;
    },
    montoFijoEsOtorgadoProductoDinamico() {
      return this.montoEntradaEsOtorgado && this.montoAprobadoSoloLectura;
    },
    etiquetaMontoProductoDinamico() {
      if (this.soloLectura) {
        return "Monto Aprobado";
      }

      return this.montoEntradaEsOtorgado ? this.etiquetaMontoOtorgamiento : "Monto Aprobado";
    },
    etiquetaResumenMontoProductoDinamico() {
      return this.esComisionProductoFinanciada ? "Monto Aprobado" : this.etiquetaMontoOtorgamiento;
    },
    montoResumenProductoDinamico() {
      return this.esComisionProductoFinanciada
        ? this.montoBaseComisionesProductoDinamico + this.totalComisionesProductoDinamico
        : this.montoOtorgarProductoDinamico;
    },
    montoOtorgarProductoDinamico() {
      if (this.esComisionProductoDescontada) {
        return Math.max(0, this.montoBaseComisionesProductoDinamico - this.totalComisionesProductoDinamico);
      }

      if (this.esComisionProductoFinanciada) {
        return this.montoBaseComisionesProductoDinamico;
      }

      return this.montoBaseComisionesProductoDinamico;
    },
    montoProductoDinamicoSoloLectura() {
      return this.soloLectura || this.montoAprobadoSoloLectura;
    },
    montoProductoDinamicoMin() {
      if (!this.montoEntradaEsOtorgado || this.montoAprobadoMin === null) {
        return this.montoAprobadoMin;
      }

      return this.redondearMonto(this.montoAprobadoMin / this.factorComisionFinanciadaProductoDinamico);
    },
    montoProductoDinamicoMax() {
      if (!this.montoEntradaEsOtorgado || this.montoAprobadoMax === null) {
        return this.montoAprobadoMax;
      }

      return this.redondearMonto(this.montoAprobadoMax / this.factorComisionFinanciadaProductoDinamico);
    },
    montoProductoDinamicoMensaje() {
      if (this.soloLectura) {
        return "";
      }

      if (!this.montoEntradaEsOtorgado) {
        return this.montoAprobadoMensaje;
      }

      if (this.montoAprobadoSoloLectura) {
        return `Monto fijo otorgado del producto: ${this.formatoNumero(this.montoProductoDinamicoModel)} ${this.moneda}.`;
      }

      if (this.montoAprobadoFueraRango) {
        return `El monto aprobado calculado debe estar entre ${this.formatoNumero(this.montoAprobadoMin)} y ${this.formatoNumero(this.montoAprobadoMax)} ${this.moneda}.`;
      }

      if (this.montoLimiteActivo && this.montoProductoDinamicoMin !== null && this.montoProductoDinamicoMax !== null) {
        return `Monto otorgado permitido: de ${this.formatoNumero(this.montoProductoDinamicoMin)} a ${this.formatoNumero(this.montoProductoDinamicoMax)} ${this.moneda}.`;
      }

      return "";
    },
    montoFijoActivo() {
      return this.toBoolean(this.productoConfiguracion.montoFijo);
    },
    montoFijoValor() {
      return this.toNumber(this.productoConfiguracion.montoFijoValue);
    },
    montoLimiteActivo() {
      return this.toBoolean(this.productoConfiguracion.montoLimiteActivo);
    },
    montoLimiteInferior() {
      return this.toNumber(this.productoConfiguracion.montoLimInf);
    },
    montoLimiteSuperior() {
      return this.toNumber(this.productoConfiguracion.montoLimSup);
    },
    tasaInteresFijoActivo() {
      return this.toBoolean(this.productoConfiguracion.tasaInteresFijo);
    },
    tasaInteresFijoValor() {
      return this.toNumber(this.productoConfiguracion.tasaInteresFijoValue);
    },
    tasaInteresLimiteActivo() {
      return this.toBoolean(this.productoConfiguracion.tasaInteresLimiteActivo);
    },
    tasaInteresLimiteInferior() {
      return this.toNumber(this.productoConfiguracion.tasaInteresLimInf);
    },
    tasaInteresLimiteSuperior() {
      return this.toNumber(this.productoConfiguracion.tasaInteresLimSup);
    },
    tasaMoraFijoActivo() {
      return this.toBoolean(this.productoConfiguracion.tasaMoraFijo);
    },
    tasaMoraFijoValor() {
      return this.toNumber(this.productoConfiguracion.tasaMoraFijoValue);
    },
    tasaMoraLimiteActivo() {
      return this.toBoolean(this.productoConfiguracion.tasaMoraLimiteActivo);
    },
    tasaMoraLimiteInferior() {
      return this.toNumber(this.productoConfiguracion.tasaMoraLimInf);
    },
    tasaMoraLimiteSuperior() {
      return this.toNumber(this.productoConfiguracion.tasaMoraLimSup);
    },
    plazoFijoActivo() {
      return this.toBoolean(this.productoConfiguracion.plazoFijo);
    },
    plazoFijoValor() {
      return this.toNumber(this.productoConfiguracion.plazoFijoValue);
    },
    plazoLimiteActivo() {
      return this.toBoolean(this.productoConfiguracion.plazoLimiteActivo);
    },
    plazoLimiteInferior() {
      return this.toNumber(this.productoConfiguracion.plazoLimInf);
    },
    plazoLimiteSuperior() {
      return this.toNumber(this.productoConfiguracion.plazoLimSup);
    },
    montoAprobadoSoloLectura() {
      return this.montoFijoActivo && this.hasNumber(this.productoConfiguracion.montoFijoValue);
    },
    montoAprobadoMin() {
      if (!this.montoLimiteActivo || !this.hasNumber(this.productoConfiguracion.montoLimInf)) {
        return null;
      }

      return this.montoLimiteInferior;
    },
    montoAprobadoMax() {
      if (!this.montoLimiteActivo || !this.hasNumber(this.productoConfiguracion.montoLimSup)) {
        return null;
      }

      return this.montoLimiteSuperior;
    },
    montoAprobadoFueraRango() {
      if (!this.montoLimiteActivo || !this.hasNumber(this.solicitud.monto)) {
        return false;
      }

      const monto = Number(this.solicitud.monto);
      const menorQueLimite = this.montoAprobadoMin !== null && monto < this.montoAprobadoMin;
      const mayorQueLimite = this.montoAprobadoMax !== null && monto > this.montoAprobadoMax;

      return menorQueLimite || mayorQueLimite;
    },
    montoAprobadoValido() {
      if (!this.montoLimiteActivo) {
        return true;
      }

      if (this.montoAprobadoMin === null || this.montoAprobadoMax === null) {
        return false;
      }

      return !this.montoAprobadoFueraRango;
    },
    montoAprobadoMensaje() {
      if (this.montoAprobadoSoloLectura) {
        return `Monto fijo del producto: ${this.formatoNumero(this.montoFijoValor)} ${this.moneda}.`;
      }

      if (this.montoAprobadoFueraRango) {
        return `El monto aprobado debe estar entre ${this.formatoNumero(this.montoAprobadoMin)} y ${this.formatoNumero(this.montoAprobadoMax)} ${this.moneda}.`;
      }

      if (this.montoLimiteActivo && this.montoAprobadoMin !== null && this.montoAprobadoMax !== null) {
        return `Monto permitido: de ${this.formatoNumero(this.montoAprobadoMin)} a ${this.formatoNumero(this.montoAprobadoMax)} ${this.moneda}.`;
      }

      if (this.montoLimiteActivo) {
        return "Este producto tiene limite de monto, pero necesita limite inferior y superior configurados.";
      }

      return "";
    },
    interesAnualSoloLectura() {
      return this.tasaInteresFijoActivo && this.hasNumber(this.productoConfiguracion.tasaInteresFijoValue);
    },
    interesAnualMin() {
      if (!this.tasaInteresLimiteActivo || !this.hasNumber(this.productoConfiguracion.tasaInteresLimInf)) {
        return null;
      }

      return this.tasaInteresLimiteInferior;
    },
    interesAnualMax() {
      if (!this.tasaInteresLimiteActivo || !this.hasNumber(this.productoConfiguracion.tasaInteresLimSup)) {
        return null;
      }

      return this.tasaInteresLimiteSuperior;
    },
    interesAnualFueraRango() {
      if (!this.tasaInteresLimiteActivo || !this.hasNumber(this.solicitud.interes)) {
        return false;
      }

      const interes = Number(this.solicitud.interes);
      const menorQueLimite = this.interesAnualMin !== null && interes < this.interesAnualMin;
      const mayorQueLimite = this.interesAnualMax !== null && interes > this.interesAnualMax;

      return menorQueLimite || mayorQueLimite;
    },
    interesAnualValido() {
      if (!this.tasaInteresLimiteActivo) {
        return true;
      }

      if (this.interesAnualMin === null || this.interesAnualMax === null) {
        return false;
      }

      return !this.interesAnualFueraRango;
    },
    interesAnualMensaje() {
      if (this.interesAnualSoloLectura) {
        return `Tasa fija del producto: ${this.formatoNumero(this.tasaInteresFijoValor)}%.`;
      }

      if (this.interesAnualFueraRango) {
        return `El interes anual debe estar entre ${this.formatoNumero(this.interesAnualMin)}% y ${this.formatoNumero(this.interesAnualMax)}%.`;
      }

      if (this.tasaInteresLimiteActivo && this.interesAnualMin !== null && this.interesAnualMax !== null) {
        return `Interes permitido: de ${this.formatoNumero(this.interesAnualMin)}% a ${this.formatoNumero(this.interesAnualMax)}%.`;
      }

      if (this.tasaInteresLimiteActivo) {
        return "Este producto tiene limite de interes, pero necesita limite inferior y superior configurados.";
      }

      return "";
    },
    tasaMoraSoloLectura() {
      return this.tasaMoraFijoActivo && this.hasNumber(this.productoConfiguracion.tasaMoraFijoValue);
    },
    tasaMoraMin() {
      if (!this.tasaMoraLimiteActivo || !this.hasNumber(this.productoConfiguracion.tasaMoraLimInf)) {
        return null;
      }

      return this.tasaMoraLimiteInferior;
    },
    tasaMoraMax() {
      if (!this.tasaMoraLimiteActivo || !this.hasNumber(this.productoConfiguracion.tasaMoraLimSup)) {
        return null;
      }

      return this.tasaMoraLimiteSuperior;
    },
    tasaMoraFueraRango() {
      if (!this.tasaMoraLimiteActivo || !this.hasNumber(this.solicitud.tasaMora)) {
        return false;
      }

      const tasaMora = Number(this.solicitud.tasaMora);
      const menorQueLimite = this.tasaMoraMin !== null && tasaMora < this.tasaMoraMin;
      const mayorQueLimite = this.tasaMoraMax !== null && tasaMora > this.tasaMoraMax;

      return menorQueLimite || mayorQueLimite;
    },
    tasaMoraValida() {
      if (!this.tasaMoraLimiteActivo) {
        return true;
      }

      if (this.tasaMoraMin === null || this.tasaMoraMax === null) {
        return false;
      }

      return !this.tasaMoraFueraRango;
    },
    tasaMoraMensaje() {
      if (this.tasaMoraSoloLectura) {
        return `Tasa moratoria fija del producto: ${this.formatoNumero(this.tasaMoraFijoValor)}%.`;
      }

      if (this.tasaMoraFueraRango) {
        return `La tasa moratoria debe estar entre ${this.formatoNumero(this.tasaMoraMin)}% y ${this.formatoNumero(this.tasaMoraMax)}%.`;
      }

      if (this.tasaMoraLimiteActivo && this.tasaMoraMin !== null && this.tasaMoraMax !== null) {
        return `Mora permitida: de ${this.formatoNumero(this.tasaMoraMin)}% a ${this.formatoNumero(this.tasaMoraMax)}%.`;
      }

      if (this.tasaMoraLimiteActivo) {
        return "Este producto tiene limite de mora, pero necesita limite inferior y superior configurados.";
      }

      return "";
    },
    plazoPagoSoloLectura() {
      return this.plazoFijoActivo
        && this.hasNumber(this.productoConfiguracion.plazoFijoValue)
        && this.plazoFijoValor > 0;
    },
    plazoPagoMin() {
      if (this.plazoLimiteActivo && this.hasNumber(this.productoConfiguracion.plazoLimInf)) {
        return this.plazoLimiteInferior;
      }

      return 1;
    },
    plazoPagoMax() {
      if (this.plazoLimiteActivo && this.hasNumber(this.productoConfiguracion.plazoLimSup)) {
        return this.plazoLimiteSuperior;
      }

      if (this.esCrediTrabajo2) {
        return 6;
      }

      return null;
    },
    plazoLimiteConfiguradoValido() {
      if (!this.plazoLimiteActivo) {
        return true;
      }

      return this.hasNumber(this.productoConfiguracion.plazoLimInf)
        && this.hasNumber(this.productoConfiguracion.plazoLimSup)
        && this.plazoLimiteInferior > 0
        && this.plazoLimiteSuperior > this.plazoLimiteInferior;
    },
    plazoPagoFueraRango() {
      if (this.plazoLimiteActivo && !this.plazoLimiteConfiguradoValido) {
        return false;
      }

      if (!this.plazoLimiteActivo && !this.esCrediTrabajo2) {
        return false;
      }

      if (!this.hasNumber(this.solicitud.plazoPago)) {
        return false;
      }

      const plazo = Number(this.solicitud.plazoPago);
      const menorQueLimite = this.plazoPagoMin !== null && plazo < this.plazoPagoMin;
      const mayorQueLimite = this.plazoPagoMax !== null && plazo > this.plazoPagoMax;

      return menorQueLimite || mayorQueLimite;
    },
    plazoPagoValido() {
      if (this.plazoFijoActivo) {
        return this.plazoPagoSoloLectura;
      }

      if (this.plazoLimiteActivo && !this.plazoLimiteConfiguradoValido) {
        return false;
      }

      if (!this.plazoLimiteActivo && !this.esCrediTrabajo2) {
        return true;
      }

      if (!this.hasNumber(this.solicitud.plazoPago)) {
        return false;
      }

      return !this.plazoPagoFueraRango;
    },
    plazoPagoMensaje() {
      if (this.plazoFijoActivo && !this.plazoPagoSoloLectura) {
        return "Este producto tiene plazo fijo, pero necesita plazo fijo valor configurado.";
      }

      if (this.plazoPagoSoloLectura) {
        return `Plazo fijo del producto: ${this.formatoNumero(this.plazoFijoValor)} meses.`;
      }

      if (this.plazoLimiteActivo && !this.plazoLimiteConfiguradoValido) {
        return "Este producto tiene limite de plazo, pero necesita limite inferior y superior configurados correctamente.";
      }

      if (this.plazoPagoFueraRango) {
        return `El plazo debe estar entre ${this.formatoNumero(this.plazoPagoMin)} y ${this.formatoNumero(this.plazoPagoMax)} meses.`;
      }

      if (this.plazoLimiteActivo) {
        return `Plazo permitido: de ${this.formatoNumero(this.plazoPagoMin)} a ${this.formatoNumero(this.plazoPagoMax)} meses.`;
      }

      return "";
    },
    mostrarPlazoFijoSemestralAnual() {
      return this.plazoPagoSoloLectura && !["6", "12", "18", "24", "36", "48", "60", "72"].includes(String(this.plazoFijoValor));
    },
    mostrarPlazoFijoTrimestral() {
      return this.plazoPagoSoloLectura && !["3", "6", "9", "12", "15", "18", "21", "24", "27", "30", "36", "48", "60", "72"].includes(String(this.plazoFijoValor));
    },
    montoProductoKey() {
      return [
        this.montoFijoActivo,
        this.productoConfiguracion.montoFijoValue,
        this.montoLimiteActivo,
        this.productoConfiguracion.montoLimInf,
        this.productoConfiguracion.montoLimSup,
      ].join("|");
    },
    tasaInteresProductoKey() {
      return [
        this.tasaInteresFijoActivo,
        this.productoConfiguracion.tasaInteresFijoValue,
        this.tasaInteresLimiteActivo,
        this.productoConfiguracion.tasaInteresLimInf,
        this.productoConfiguracion.tasaInteresLimSup,
      ].join("|");
    },
    tasaMoraProductoKey() {
      return [
        this.tasaMoraFijoActivo,
        this.productoConfiguracion.tasaMoraFijoValue,
        this.tasaMoraLimiteActivo,
        this.productoConfiguracion.tasaMoraLimInf,
        this.productoConfiguracion.tasaMoraLimSup,
      ].join("|");
    },
    plazoProductoKey() {
      return [
        this.plazoFijoActivo,
        this.productoConfiguracion.plazoFijoValue,
        this.plazoLimiteActivo,
        this.productoConfiguracion.plazoLimInf,
        this.productoConfiguracion.plazoLimSup,
      ].join("|");
    },
    condicionesEspecialesProductoKey() {
      return [
        this.productoConfiguracion.id || "",
        this.productoTieneCampo("fechaFijaActiva"),
        this.productoConfiguracion.fechaFijaActiva,
        this.productoConfiguracion.fechaFijaValue,
        this.productoTieneCampo("sinMoraActiva"),
        this.productoConfiguracion.sinMoraActiva,
        this.productoConfiguracion.sinMoraValue,
        this.productoTieneCampo("periodoGraciaActivo"),
        this.productoConfiguracion.periodoGraciaActivo,
        this.productoConfiguracion.periodoGraciaValue,
      ].join("|");
    },
    montoComisionProductoKey() {
      return [
        this.mostrarComisionesProductoDinamico,
        this.tipoComisionProductoDinamicoNormalizado,
        this.montoEntradaEsOtorgado
          ? this.montoBaseComisionesProductoDinamico
          : this.solicitud.monto,
        this.comisionesConfiguradasProductoDinamico
          .map((comision) => `${comision.nombre}:${comision.porcentaje}`)
          .join(","),
      ].join("|");
    },
    productoSeleccionadoIdModel: {
      get() {
        return this.productoSeleccionadoId;
      },
      set(value) {
        this.$emit("update:producto-seleccionado-id", value);
      },
    },
    montoProductoDinamicoModel: {
      get() {
        if (this.soloLectura) {
          return this.solicitud.monto;
        }

        if (this.montoFijoEsOtorgadoProductoDinamico) {
          return this.montoFijoValor;
        }

        if (this.montoEntradaEsOtorgado) {
          return this.montoOtorgadoReferenciaProductoDinamico;
        }

        return this.solicitud.monto;
      },
      set(value) {
        this.actualizarMontoProductoDinamicoDesdeInput(value);
      },
    },
    montoOtorgarModel: {
      get() {
        return this.montoOtorgar;
      },
      set(value) {
        this.$emit("update:monto-otorgar", value);
      },
    },
  },
  watch: {
    montoProductoKey: {
      immediate: true,
      handler() {
        this.aplicarReglasMontoProducto();
        this.emitirValidacionMonto();
      },
    },
    montoAprobadoValido: {
      immediate: true,
      handler() {
        this.emitirValidacionMonto();
      },
    },
    montoComisionProductoKey: {
      immediate: true,
      handler() {
        this.aplicarMontosComisionProductoDinamico();
      },
    },
    tasaInteresProductoKey: {
      immediate: true,
      handler() {
        this.aplicarReglasTasaInteresProducto();
        this.emitirValidacionInteres();
      },
    },
    interesAnualValido: {
      immediate: true,
      handler() {
        this.emitirValidacionInteres();
      },
    },
    tasaMoraProductoKey: {
      immediate: true,
      handler() {
        this.aplicarReglasTasaMoraProducto();
        this.emitirValidacionMora();
      },
    },
    tasaMoraValida: {
      immediate: true,
      handler() {
        this.emitirValidacionMora();
      },
    },
    plazoProductoKey: {
      immediate: true,
      handler() {
        this.aplicarReglasPlazoProducto();
        this.emitirValidacionPlazo();
      },
    },
    plazoPagoValido: {
      immediate: true,
      handler() {
        this.emitirValidacionPlazo();
      },
    },
    periodosPagoDisponibles: {
      immediate: true,
      handler() {
        this.aplicarPeriodoPagoProducto();
      },
    },
    condicionesEspecialesProductoKey: {
      immediate: true,
      handler() {
        this.aplicarReglasCondicionesProducto();
      },
    },
    "solicitud.fechaFija"() {
      this.aplicarReglasCondicionesProducto();
    },
    "solicitud.sinMora"() {
      this.aplicarReglasCondicionesProducto();
    },
    "solicitud.periodoGracia"() {
      this.aplicarReglasCondicionesProducto();
    },
  },
  methods: {
    productoTieneCampo(campo) {
      return Object.prototype.hasOwnProperty.call(this.productoConfiguracion || {}, campo);
    },
    toBoolean(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    hasNumber(value) {
      return value !== "" && value !== null && value !== undefined && Number.isFinite(Number(value));
    },
    toNumber(value) {
      return this.hasNumber(value) ? Number(value) : null;
    },
    redondearMonto(value) {
      return this.hasNumber(value) ? Math.round(Number(value) * 100) / 100 : 0;
    },
    normalizarTexto(value) {
      return String(value || "").trim().toLowerCase();
    },
    normalizarPeriodoTexto(value) {
      return this.normalizarTexto(value);
    },
    normalizarPeriodosPago(periodos) {
      let listaPeriodos = [];

      if (Array.isArray(periodos)) {
        listaPeriodos = periodos;
      } else if (typeof periodos === "string") {
        const texto = periodos.trim();

        if (texto.startsWith("[")) {
          try {
            const periodosParseados = JSON.parse(texto);
            listaPeriodos = Array.isArray(periodosParseados) ? periodosParseados : [];
          } catch (error) {
            listaPeriodos = texto.split(",");
          }
        } else {
          listaPeriodos = texto.split(",");
        }
      }

      return Array.from(
        new Set(
          listaPeriodos
            .map((periodo) => String(periodo || "").trim())
            .filter((periodo) => periodo !== "")
        )
      );
    },
    aplicarPeriodoPagoProducto() {
      if (this.soloLectura) {
        return;
      }

      const periodos = this.periodosPagoDisponibles;

      if (periodos.length === 0) {
        return;
      }

      if (this.periodosPagoProducto.length === 0 && !this.esCrediTrabajo2) {
        return;
      }

      const periodoActual = this.normalizarPeriodoTexto(this.solicitud.frecuenciaPago);
      const periodoEncontrado = periodos.find(
        (periodo) => this.normalizarPeriodoTexto(periodo) === periodoActual
      );

      if (periodoEncontrado) {
        if (this.solicitud.frecuenciaPago !== periodoEncontrado) {
          this.solicitud.frecuenciaPago = periodoEncontrado;
        }
        return;
      }

      this.solicitud.frecuenciaPago = periodos[0];
    },
    aplicarReglasCondicionesProducto() {
      if (this.soloLectura) {
        return;
      }

      if (this.productoTieneCampo("fechaFijaActiva")) {
        if (!this.fechaFijaProductoActiva && this.solicitud.fechaFija) {
          this.solicitud.fechaFija = false;
        } else if (this.fechaFijaProductoFija && this.solicitud.fechaFija !== true) {
          this.solicitud.fechaFija = true;
        }
      }

      if (this.productoTieneCampo("sinMoraActiva")) {
        if (!this.sinMoraProductoActiva && this.solicitud.sinMora) {
          this.solicitud.sinMora = false;
        } else if (this.sinMoraProductoFija && this.solicitud.sinMora !== true) {
          this.solicitud.sinMora = true;
        }
      }

      if (!this.productoTieneCampo("periodoGraciaActivo")) {
        return;
      }

      if (!this.periodoGraciaProductoActivo) {
        if (Number(this.solicitud.periodoGracia || 0) !== 0) {
          this.solicitud.periodoGracia = 0;
        }
        return;
      }

      if (!this.periodoGraciaProductoFijo) {
        return;
      }

      const periodoGracia = this.periodoGraciaProductoValor ?? 0;
      if (Number(this.solicitud.periodoGracia || 0) !== periodoGracia) {
        this.solicitud.periodoGracia = periodoGracia;
      }
    },
    calcularTotalComisionesProductoDinamico(base) {
      return this.redondearMonto(
        this.comisionesConfiguradasProductoDinamico.reduce(
          (total, comision) => total + ((Number(comision.porcentaje) / 100) * Number(base || 0)),
          0
        )
      );
    },
    calcularMontoAprobadoFinanciado(montoOtorgado) {
      return this.redondearMonto(
        Number(montoOtorgado || 0) + this.calcularTotalComisionesProductoDinamico(montoOtorgado)
      );
    },
    calcularMontoOtorgadoDesdeAprobadoFinanciado(montoAprobado) {
      if (this.factorComisionFinanciadaProductoDinamico <= 0) {
        return 0;
      }

      return this.redondearMonto(Number(montoAprobado || 0) / this.factorComisionFinanciadaProductoDinamico);
    },
    montosIguales(montoA, montoB) {
      if (this.hasNumber(montoA) && this.hasNumber(montoB)) {
        return Math.abs(Number(montoA) - Number(montoB)) < 0.005;
      }

      return String(montoA || "") === String(montoB || "");
    },
    actualizarMontoOtorgarProductoDinamico(value) {
      const monto = this.hasNumber(value) ? this.redondearMonto(value) : value;

      if (!this.montosIguales(this.solicitud.montoOtorgar, monto)) {
        this.solicitud.montoOtorgar = monto;
      }

      if (!this.montosIguales(this.montoOtorgar, monto)) {
        this.$emit("update:monto-otorgar", monto);
      }
    },
    actualizarMontoProductoDinamicoDesdeInput(value) {
      if (this.soloLectura) {
        return;
      }

      if (!this.mostrarComisionesProductoDinamico) {
        this.solicitud.monto = value;
        return;
      }

      const monto = this.toNumber(value);

      if (this.esComisionProductoFinanciada) {
        this.actualizarMontoOtorgarProductoDinamico(value);
        this.solicitud.monto = monto === null ? value : this.calcularMontoAprobadoFinanciado(monto);
        return;
      }

      this.solicitud.monto = value;
      if (monto !== null) {
        this.aplicarMontosComisionProductoDinamico();
      }
    },
    aplicarMontosComisionProductoDinamico() {
      if (this.soloLectura) {
        return;
      }

      if (!this.mostrarComisionesProductoDinamico) {
        return;
      }

      if (this.esComisionProductoFinanciada) {
        const montoOtorgado = this.montoFijoEsOtorgadoProductoDinamico
          ? this.montoFijoValor
          : this.montoOtorgadoReferenciaProductoDinamico;
        if (!this.hasNumber(montoOtorgado)) {
          return;
        }

        const nuevoMontoAprobado = this.calcularMontoAprobadoFinanciado(montoOtorgado);

        this.actualizarMontoOtorgarProductoDinamico(montoOtorgado);
        if (!this.montosIguales(this.solicitud.monto, nuevoMontoAprobado)) {
          this.solicitud.monto = nuevoMontoAprobado;
        }
        return;
      }

      const montoAprobado = this.toNumber(this.solicitud.monto);
      if (montoAprobado === null) {
        return;
      }

      const montoOtorgado = this.esComisionProductoDescontada
        ? Math.max(0, montoAprobado - this.totalComisionesProductoDinamico)
        : montoAprobado;

      this.actualizarMontoOtorgarProductoDinamico(this.redondearMonto(montoOtorgado));
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero);
    },
    aplicarReglasMontoProducto() {
      if (this.soloLectura) {
        return;
      }

      if (!this.montoAprobadoSoloLectura) {
        return;
      }

      if (this.montoFijoEsOtorgadoProductoDinamico) {
        this.aplicarMontosComisionProductoDinamico();
        return;
      }

      if (Number(this.solicitud.monto) === this.montoFijoValor) {
        return;
      }

      this.solicitud.monto = this.montoFijoValor;
      this.aplicarMontosComisionProductoDinamico();
      if (this.esCreaFuturo) {
        this.$nextTick(() => this.onBlur());
      }
    },
    validarMontoAprobado() {
      if (this.soloLectura) {
        return;
      }

      if (this.montoAprobadoSoloLectura && !this.montoFijoEsOtorgadoProductoDinamico) {
        this.solicitud.monto = this.montoFijoValor;
      }

      this.aplicarMontosComisionProductoDinamico();
    },
    handleMontoAprobadoBlur(emitirCalculo) {
      if (this.soloLectura) {
        return;
      }

      this.validarMontoAprobado();
      this.emitirValidacionMonto();

      if (emitirCalculo) {
        this.onBlur();
      }
    },
    emitirValidacionMonto() {
      this.$emit("validacion-monto", this.montoAprobadoValido);
    },
    aplicarReglasTasaInteresProducto() {
      if (this.soloLectura) {
        return;
      }

      if (!this.interesAnualSoloLectura) {
        return;
      }

      if (Number(this.solicitud.interes) === this.tasaInteresFijoValor) {
        return;
      }

      this.solicitud.interes = this.tasaInteresFijoValor;
    },
    validarInteresAnual() {
      if (this.soloLectura) {
        return;
      }

      if (this.interesAnualSoloLectura) {
        this.solicitud.interes = this.tasaInteresFijoValor;
      }

      this.emitirValidacionInteres();
    },
    handleInteresAnualBlur() {
      this.validarInteresAnual();
    },
    emitirValidacionInteres() {
      this.$emit("validacion-interes", this.interesAnualValido);
    },
    aplicarReglasTasaMoraProducto() {
      if (this.soloLectura) {
        return;
      }

      if (!this.tasaMoraSoloLectura) {
        return;
      }

      if (Number(this.solicitud.tasaMora) === this.tasaMoraFijoValor) {
        return;
      }

      this.solicitud.tasaMora = this.tasaMoraFijoValor;
    },
    validarTasaMora() {
      if (this.soloLectura) {
        return;
      }

      if (this.tasaMoraSoloLectura) {
        this.solicitud.tasaMora = this.tasaMoraFijoValor;
      }

      this.emitirValidacionMora();
    },
    handleTasaMoraBlur() {
      this.validarTasaMora();
    },
    emitirValidacionMora() {
      this.$emit("validacion-mora", this.tasaMoraValida);
    },
    aplicarReglasPlazoProducto() {
      if (this.soloLectura) {
        return;
      }

      if (!this.plazoPagoSoloLectura) {
        return;
      }

      if (Number(this.solicitud.plazoPago) === this.plazoFijoValor) {
        return;
      }

      this.solicitud.plazoPago = this.plazoFijoValor;
    },
    validarPlazoPago() {
      if (this.soloLectura) {
        return;
      }

      if (this.plazoPagoSoloLectura) {
        this.solicitud.plazoPago = this.plazoFijoValor;
      }

      this.emitirValidacionPlazo();
    },
    handlePlazoPagoBlur() {
      this.validarPlazoPago();
    },
    emitirValidacionPlazo() {
      this.$emit("validacion-plazo", this.plazoPagoValido);
    },
    seleccionarProductoPorId() {
      if (this.soloLectura) {
        return;
      }

      this.$emit("seleccionar-producto");
    },
    onBlur() {
      if (this.soloLectura) {
        return;
      }

      this.$emit("blur-monto");
    },
  },
};
</script>

<style scoped>
.accordion-item {
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06) !important;
}

.accordion-header {
  border-radius: 14px !important;
}

.accordion-button {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%) !important;
  color: #111827 !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.9rem 1rem !important;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(120deg, #111827 0%, #1f2937 100%) !important;
  color: #f9fafb !important;
}

.accordion-button::after {
  filter: grayscale(0.2) contrast(1.2) !important;
}

.accordion-button:not(.collapsed)::after {
  filter: brightness(2.5) !important;
}

.accordion-body {
  background: #ffffff !important;
  padding: 1rem !important;
}

.condiciones-fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

#contenedor-plan {
  width: 100%;
  max-width: 100%;
  margin-top: 18px;
  padding: clamp(18px, 3vw, 32px);
  overflow: auto;
  background: #fff;
  border: 1px solid #dce7e1;
  border-radius: 8px;
  box-shadow: 0 16px 34px rgba(31, 43, 37, 0.08);
}

#contenedor-plan > .header {
  width: 100%;
  margin-bottom: 22px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #d8e5de;
  border-radius: 8px;
}

#contenedor-plan > .header > .row {
  width: 100%;
  margin: 0;
}

#frmPrestamo {
  padding: 4px 2px 0;
}

#frmPrestamo .condiciones-grid {
  row-gap: 12px;
}

.condiciones-column {
  display: flex;
  flex-direction: column;
}

.condiciones-column--right {
  align-items: stretch;
}

.condiciones-column .control {
  margin-bottom: 16px;
}

.condiciones-column .control:last-child {
  margin-bottom: 0;
}

#frmPrestamo .control label {
  margin-bottom: 6px;
  color: #263a31;
  font-weight: 600;
}

#frmPrestamo .form-control,
#frmPrestamo .form-select {
  height: 44px;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #d7e1dc;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: none;
}

#frmPrestamo .form-control:focus,
#frmPrestamo .form-select:focus {
  border-color: #2f7d5c;
  box-shadow: 0 0 0 3px rgba(47, 125, 92, 0.16);
}

#frmPrestamo h4 {
  margin-bottom: 14px;
  color: #163629;
  font-weight: 700;
}

.monto-ayuda {
  display: block;
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 0.86rem;
  line-height: 1.35;
}

.interes-ayuda {
  margin-bottom: 12px;
}

.comisiones-producto {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 12px;
  margin-right: auto;
  margin-left: auto;
  border: 1px solid #dbe7e1;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: none;
}

.comisiones-producto__header,
.comisiones-producto__summary,
.comisiones-producto__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.comisiones-producto__header {
  padding-bottom: 8px;
  border-bottom: 1px solid #e3ece7;
}

.comisiones-producto__eyebrow {
  margin: 0 0 2px;
  color: #2f7d5c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.comisiones-producto h5 {
  margin: 0;
  color: #163629;
  font-size: 0.95rem;
  font-weight: 800;
}

.comisiones-producto__badge {
  min-width: 96px;
  padding: 5px 10px;
  border: 1px solid #b8d6c7;
  border-radius: 999px;
  background: #ffffff;
  color: #1f674c;
  font-size: 0.76rem;
  font-weight: 800;
  text-align: center;
  text-transform: capitalize;
}

.comisiones-producto__summary {
  margin-top: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  background: #ffffff;
}

.comisiones-producto__summary span,
.comisiones-producto__total span,
.comisiones-producto__row span {
  color: #61736a;
  font-size: 0.74rem;
  font-weight: 700;
}

.comisiones-producto__summary strong {
  color: #143f2e;
  font-size: 0.98rem;
  font-weight: 800;
}

.comisiones-producto__list {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}

.comisiones-producto__row {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(110px, 0.7fr) minmax(130px, 0.9fr);
  gap: 10px;
  align-items: center;
  padding: 9px 10px;
  border: 1px solid #e1ebe6;
  border-radius: 8px;
  background: #ffffff;
}

.comisiones-producto__row div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.comisiones-producto__row strong {
  overflow-wrap: anywhere;
  color: #263a31;
  font-size: 0.88rem;
  font-weight: 800;
}

.comisiones-producto__total {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e3ece7;
}

.comisiones-producto__total strong {
  color: #163629;
  font-size: 1rem;
  font-weight: 900;
}

@media (max-width: 768px) {
  #contenedor-plan {
    padding: 16px;
  }

  #contenedor-plan > .header {
    padding: 14px;
  }

  .comisiones-producto {
    padding: 12px;
  }

  .comisiones-producto__header,
  .comisiones-producto__summary,
  .comisiones-producto__total {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .comisiones-producto__badge {
    min-width: 0;
  }

  .comisiones-producto__row {
    grid-template-columns: 1fr;
  }
}
</style>
